import React from 'react'
import './Project.css'
function Projects() {
  return (
    <div className="container">
      <h1
        className="text-center my-5 fw-light"
        style={{
          color: "navy",
        }}
      >
        {" "}
        Personal Projects
      </h1>
      <div className="row">
        <div className="col-md-6">
          <div className="card text-center mx-2 my-2">
            <div className="card-body">
              <h5 className="card-title">
                INSTITUTE WEBSITE PROTOTYPE{" "}
                <span className="text-muted"> (09/2020 - 12/2020)</span>
              </h5>
              <p className="card-text">
                I, along with five team member worked together as a team for
                making this project. This project made use of html, css ,
                javascript and frontend libraries to develop the complete
                application.
              </p>
              <a
                href="https://abhishek1342.github.io/IIITK-website/"
                class="btn btn-primary"
                target="_blank"
              >
                Launch
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card text-center mx-2 my-2">
            <div className="card-body">
              <h5 className="card-title">
                NewsMonkey{" "}
                <span className="text-muted"> (09/2020 - 12/2020)</span>
              </h5>
              <p className="card-text">
                This is a project which uses a public api key for fetching the
                daily news and display it in my applicaiton. News can be
                categorised based on sports, business , health... This helped me
                understanding different routing and fetching method in react.
              </p>
              <a
                href="https://github.com/amadawni/newMonkey"
                class="btn btn-primary"
                target="_blank"
              >
                Visit Codebase
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card text-center mx-2 my-2">
            <div className="card-body">
              <h5 className="card-title">
                iNotebook - your notes in cloud{" "}
                <span className="text-muted"> (02/2022 - 03/2022)</span>
              </h5>
              <p className="card-text">
                This project is real life note keeping application in which
                anyone can login/ sign up to his account and add, update, delete
                his notes from his account. This project helped me in
                understanding how api call takes place in frontend and different
                method of routes to make application. In this project i used
                node, express js, mongo db(mongoose model) and react .
              </p>
              <a
                href="https://github.com/amadawni/iNotebook"
                class="btn btn-primary"
                target="_blank"
              >
                View Codebase
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card text-center mx-2 my-2">
            <div className="card-body">
              <h5 className="card-title">
                TextUtils - A React Based App{" "}
                <span className="text-muted"> (01/2022 - 02/2022)</span>
              </h5>
              <p className="card-text">
                A simple react based app which may be helpful in editing and
                working/playing with any given english para. This project used
                the frontend concept of react js. I learnt concept like jsx,
                props, state and different react hooks.
              </p>
              <a
                href="https://text-transformer-with-amrit.netlify.app/"
                class="btn btn-primary"
                target="_blank"
              >
                Launch
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <hr /> */}
    </div>
  );
}

export default Projects